<template>
    <div id="faq" class="faq-section">
        <h2 class="faq-title">Preguntas Frecuentes</h2>
        <div class="faq-list">
            <div v-for="(item, index) in faqItems" :key="index" class="faq-item">
                <button class="faq-question" @click="toggleAnswer(index)" :aria-expanded="item.isOpen" :aria-controls="'faq-answer-' + index">
                    {{ item.question }}
                    <span class="faq-icon">{{ item.isOpen ? '−' : '+' }}</span>
                </button>
                <div :id="'faq-answer-' + index" class="faq-answer" :class="{ 'faq-answer-open': item.isOpen }" v-show="item.isOpen">
                    {{ item.answer }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FAQ',
    data() {
        return {
            faqItems: [
                {
                    question: '¿Las cuentas son legales?',
                    answer: 'Sí, todas las cuentas de stock que ofrecemos para la venta cumplen con la normativa de facturación legal.',
                    isOpen: false,
                },
                {
                    question: '¿Las cuentas son a dominio?',
                    answer: 'Todos nuestros productos son de dominio exclusivo del cliente, a excepción de las cuentas de Spotify.',
                    isOpen: false,
                },
                {
                    question: '¿Qué métodos de pago manejan?',
                    answer: 'Actualmente, aceptamos únicamente pagos a través de Binance.',
                    isOpen: false,
                },
                {
                    question: '¿Cuánto tiempo demora la activación de las cuentas?',
                    answer: 'Una vez que se ha realizado el pago, el tiempo estimado para la activación de las cuentas es de entre 20 y 40 minutos.',
                    isOpen: false,
                },
                {
                    question: '¿Tienen garantía?',
                    answer: 'Cada producto incluye un tiempo de garantía específico, el cual se detalla en la descripción correspondiente.',
                    isOpen: false,
                },
            ],
        };
    },
    methods: {
        toggleAnswer(index) {
            this.faqItems[index].isOpen = !this.faqItems[index].isOpen;
        },
    },
};
</script>

<style scoped>
.faq-section {
    margin: 3rem auto;
    padding: 2rem;
    background: var(--color-card);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
}

.faq-title {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 2rem;
    background: linear-gradient(to right, var(--color-primary), var(--color-accent));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.faq-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
}

.faq-item {
    background: var(--color-background);
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
}

.faq-question {
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    padding: 1.25rem;
    color: var(--color-text);
    font-size: 1rem;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.faq-question:hover {
    color: var(--color-accent);
}

.faq-icon {
    font-size: 1.25rem;
    color: var(--color-accent);
    transition: transform 0.3s ease;
    flex-shrink: 0;
    margin-left: 1rem;
}

.faq-answer {
    padding: 0;
    color: var(--color-text-muted);
    line-height: 1.5;
    font-size: 1rem;
    text-align: justify;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: all 0.3s ease;
    box-sizing: border-box;
    width: 100%;
}

.faq-answer-open {
    padding: 0 1.25rem 1.25rem 1.25rem;
    max-height: none;
    opacity: 1;
}

@media (max-width: 768px) {
    .faq-section {
        margin: 2rem auto;
        padding: 1.5rem;
        width: 100%;
    }

    .faq-title {
        font-size: 1.75rem;
    }

    .faq-question {
        padding: 1rem;
        font-size: 0.95rem;
    }

    .faq-answer {
        font-size: 0.9rem;
        text-align: justify;
    }

    .faq-answer-open {
        padding: 0 1rem 1rem 1rem;
    }
}

@media (max-width: 480px) {
    .faq-section {
        padding: 1rem;
    }

    .faq-title {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
    }

    .faq-question {
        padding: 0.875rem;
        font-size: 0.9rem;
    }

    .faq-answer {
        font-size: 0.9rem;
        text-align: justify;
    }

    .faq-answer-open {
        padding: 0 0.875rem 0.875rem 0.875rem;
    }
}
</style>
